<form [formGroup]="form">
	<div class="flex flex-col gap-2">
		<span class="text-gray-700">
			{{ data.invitee.name }}'s email address is missing.
		</span>

		<p class="text-sm text-gray-700">
			For client intake forms to remain secure email addresses must be
			up-to-date. Add details below.
		</p>

		<div class="pb-4">
			<app-input
				name="email"
				type="email"
				startIcon="fa-envelope"
				formControlName="email"
				placeholder="Add email address"
				[class]="
					form.get('email')!.invalid && form.get('email')!.touched
						? 'border-red-700 focus:ring-red-700'
						: ''
				"
			/>
		</div>
	</div>
</form>
